// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================
import {
	MessageBackend as createMessageBackendConfluenceCreateASpace,
	MessageFrontend as createMessageFrontendConfluenceCreateASpace,
} from '@post-office/message-template--confluence-create-a-space/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceResurrectedUserWelcomeSideBarNudge,
	MessageFrontend as createMessageFrontendConfluenceResurrectedUserWelcomeSideBarNudge,
} from '@post-office/message-template--confluence-resurrected-user-welcome-sidebar-nudge/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceSideNav1On1LoomNudge,
	MessageFrontend as createMessageFrontendConfluenceSideNav1On1LoomNudge,
} from '@post-office/message-template--confluence-side-nav-1-on-1-loom-nudge/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceSideNavCreateASpace,
	MessageFrontend as createMessageFrontendConfluenceSideNavCreateASpace,
} from '@post-office/message-template--confluence-side-nav-create-a-space/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceCreateWithRovoSideNavNudge,
	MessageFrontend as createMessageFrontendConfluenceCreateWithRovoSideNavNudge,
} from '@post-office/message-template--confluence-create-with-rovo-side-nav-nudge/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendRovoExtensionInstallCta,
	MessageFrontend as createMessageFrontendRovoExtensionInstallCta,
} from '@post-office/message-template--rovo-extension-install-cta-left-nav/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendTwcSidenavBanner,
	MessageFrontend as createMessageFrontendTwcSidenavBanner,
} from '@post-office/message-template--twc-sidenav-banner/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendTwcSidenavAaBanner,
	MessageFrontend as createMessageFrontendTwcSidenavAaBanner,
} from '@post-office/message-template--twc-sidenav-a-a-banner/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluenceRovoOnboardingBanner,
	MessageFrontend as createMessageFrontendConfluenceRovoOnboardingBanner,
} from '@post-office/message-template--confluence-rovo-onboarding-banner/placements/in-app-v2/confluence-side-nav';
import {
	MessageBackend as createMessageBackendConfluence3pToolsNudgeBanner,
	MessageFrontend as createMessageFrontendConfluence3pToolsNudgeBanner,
} from '@post-office/message-template--confluence-3p-tools-nudge-banner/placements/in-app-v2/confluence-side-nav';
import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';
import {
	PlacementBackend,
	PlacementFrontend,
    type PlacementFrontendProps,
} from '@post-office/placements--growth/confluence-side-nav';
import { type PlacementRestMiddlewareConfig } from '@post-office/placement-common-v2';
import { type PlacementBackendRuntime, type PlacementRendererStage } from '@post-office/placement-common-v2/create-placement/types';

const messageBackends = [
	createMessageBackendConfluenceCreateASpace({ messageTemplateId: 'confluence-create-a-space' }),
	createMessageBackendConfluenceSideNavCreateASpace({
		messageTemplateId: 'confluence-side-nav-create-a-space',
	}),
	createMessageBackendConfluenceSideNav1On1LoomNudge({
		messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge',
	}),
	createMessageBackendConfluenceResurrectedUserWelcomeSideBarNudge({
		messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge',
	}),
	createMessageBackendConfluenceCreateWithRovoSideNavNudge({
		messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge',
	}),
	createMessageBackendRovoExtensionInstallCta({
		messageTemplateId: 'rovo-extension-install-cta-left-nav',
	}),
	createMessageBackendTwcSidenavBanner({ messageTemplateId: 'twc-sidenav-banner' }),
	createMessageBackendTwcSidenavAaBanner({ messageTemplateId: 'twc-sidenav-a-a-banner' }),
	createMessageBackendConfluenceRovoOnboardingBanner({
		messageTemplateId: 'confluence-rovo-onboarding-banner',
	}),
	createMessageBackendConfluence3pToolsNudgeBanner({
		messageTemplateId: 'confluence-3p-tools-nudge-banner',
	}),
];

const messageFrontends = [
	createMessageFrontendConfluenceCreateASpace({ messageTemplateId: 'confluence-create-a-space' }),
	createMessageFrontendConfluenceSideNavCreateASpace({
		messageTemplateId: 'confluence-side-nav-create-a-space',
	}),
	createMessageFrontendConfluenceSideNav1On1LoomNudge({
		messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge',
	}),
	createMessageFrontendConfluenceResurrectedUserWelcomeSideBarNudge({
		messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge',
	}),
	createMessageFrontendConfluenceCreateWithRovoSideNavNudge({
		messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge',
	}),
	createMessageFrontendRovoExtensionInstallCta({
		messageTemplateId: 'rovo-extension-install-cta-left-nav',
	}),
	createMessageFrontendTwcSidenavBanner({ messageTemplateId: 'twc-sidenav-banner' }),
	createMessageFrontendTwcSidenavAaBanner({
		 messageTemplateId: 'twc-sidenav-a-a-banner' }),
	createMessageFrontendConfluenceRovoOnboardingBanner({
		messageTemplateId: 'confluence-rovo-onboarding-banner',
	}),
	createMessageFrontendConfluence3pToolsNudgeBanner({
		messageTemplateId: 'confluence-3p-tools-nudge-banner',
	}),
];

export const placementBackendFactory: (runtime: PlacementBackendRuntime) => PlacementRestMiddlewareConfig = PlacementBackend.createPlacementBackend({
	messageTemplates: messageBackends,
});

export const Placement: PlacementRendererStage<PlacementFrontendProps> = PlacementFrontend.createPlacementFrontendComponent({
	messageTemplates: messageFrontends,
});

export const middleware: PlacementRestMiddlewareConfig = placementBackendFactory(productionRuntime);
